export enum SidebarType {
  TAB = 'TAB',
  GROUP = 'GROUP',
  TABGROUP = 'TABGROUP',
  TABGROUPITEM = 'TABGROUPITEM',
}
